
import { defineComponent } from 'vue'
import { iScorecard } from './Scorecards'
import { AxiosResponse } from 'axios'
import { filterDefault } from '@/helpers/commons/filterHelper'
import { formatDate } from '@/helpers/commons/localeHelper'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import KnFabButton from '@/components/UI/KnFabButton.vue'
import moment from 'moment'
import scorecardsDescriptor from './ScorecardsDescriptor.json'

export default defineComponent({
    name: 'scorecards',
    components: { Column, DataTable, KnFabButton },
    data() {
        return {
            scorecardsDescriptor,
            scorecards: [] as iScorecard[],
            filters: { global: [filterDefault] }
        }
    },
    computed: {},
    async created() {
        await this.loadScorecards()
    },
    methods: {
        async loadScorecards() {
            this.$store.commit('setLoading', true)
            await this.$http.get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `1.0/kpiee/listScorecard`).then((response: AxiosResponse<any>) => (this.scorecards = response.data))
            this.$store.commit('setLoading', false)
        },
        getFormattedDate(date: number) {
            const tempDate = moment(date).format('DD/MM/YYYY')
            return formatDate(tempDate, '', 'DD/MM/YYYY')
        },
        openScorecardDetail(scorecard: iScorecard | null = null) {
            const path = scorecard ? `/scorecards/${scorecard.id}` : '/scorecards/new-scorecard'
            this.$router.push(path)
        },
        deleteScorecardConfirm(scorecard: iScorecard) {
            this.$confirm.require({
                message: this.$t('common.toast.deleteMessage'),
                header: this.$t('common.toast.deleteConfirmTitle'),
                icon: 'pi pi-exclamation-triangle',
                accept: () => this.deleteScorecard(scorecard)
            })
        },
        async deleteScorecard(scorecard: iScorecard) {
            await this.$http
                .delete(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `1.0/kpiee/${scorecard.id}/deleteScorecard`)
                .then(() => {
                    this.$store.commit('setInfo', {
                        title: this.$t('common.toast.deleteTitle'),
                        msg: this.$t('common.toast.deleteSuccess')
                    })
                    this.removeScorecard(scorecard)
                })
                .catch(() => {})
        },
        removeScorecard(scorecard: iScorecard) {
            const index = this.scorecards.findIndex((tempScorecard: iScorecard) => tempScorecard.id === scorecard.id)
            if (index !== -1) this.scorecards.splice(index, 1)
        }
    }
})
